import GTag from './GTag.vue'

export { GTag }

export default GTag
